<template>
     <div id="myechart"></div>
</template>

<script>
export default {
  components: {
  },
  name: 'echart',
  data () {
    return {
      Width: 35,
      Height: 50,
      X: 30,
      Y: 40,
      left: 50,
      top: 12,
      itemHeight: 8,
      itemWidth: 16,
      itemGap: 12,
      myChart: null
    }
  },
  props: ['data'],
  mounted () {
    this.$nextTick(() => {
      this.initChart()
    })
    var self = this
    window.onresize = function () {
      self.updateEh()
    }
  },
  destroyed () {
    window.onresize = null
  },
  computed: {
    Edata () {
      var arr = []
      this.data.forEach(item => {
        arr.push(item.name)
      })
      return arr
    }
  },
  methods: {
    updateEh () {
      var oWidth1 = document.body.clientWidth || document.documentElement.clientWidth
      var myE = document.getElementById('myechart')
      myE.style.width = oWidth1 / 1496 * 300 + 'px'
      myE.style.height = oWidth1 / 1496 * 240 + 'px'
      this.Width = oWidth1 / 1496 * 35
      this.Height = oWidth1 / 1496 * 50
      this.X = oWidth1 / 1496 * 30
      this.Y = oWidth1 / 1496 * 40
      this.left = oWidth1 / 1496 * 50
      this.top = oWidth1 / 1496 * 12
      this.itemGap = oWidth1 / 1496 * 12
      this.itemHeight = oWidth1 / 1496 * 8
      this.itemWidth = oWidth1 / 1496 * 16
      this.initChart()
    },
    initChart () {
      this.myChart = this.$echarts.init(document.getElementById('myechart'))
      var self = this
      this.myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: self.left + '%',
          top: self.top + '%',
          data: self.Edata,
          itemWidth: self.itemWidth,
          itemHeight: self.itemHeight,
          itemGap: self.itemGap,
          color: ['#01A3FF', '#FF5679', '#A157EC', '#FFD300', '#00CF69', '#749f83']
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: [self.Width + '%', self.Height + '%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            color: ['#01A3FF', '#FF5679', '#A157EC', '#FFD300', '#00CF69', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false,
              data: this.data
            },
            width: '80%',
            center: [self.X + '%', self.Y + '%'],
            data: this.data
          }
        ]
      })
    }
  },
  watch: {
    myChart () {
      this.$nextTick(() => {
        this.updateEh()
      })
    }
  }
}
</script>

<style>
#myechart{
  width:300px;
  height:240px;
}
</style>
